<template>
  <form class="form form-loyalty-signup-sides mb-0" @submit.prevent="postSides">
    <slide-x-left-transition :duration="400" :delay="300">
      <div class="form-group" v-show="show">
        <label>Imię:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="contractor_first_name"
                 :class="{'input-error' : errors['contractor_data.first_name'] }"
                 placeholder="Imię">
          <p class="error"
             v-if="errors['contractor_data.first_name']"
             v-text="errors['contractor_data.first_name'][0]">
          </p>
        </div>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="400">
      <div class="form-group" v-show="show">
        <label>Nazwisko:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="contractor_last_name"
                 :class="{'input-error' : errors['contractor_data.last_name'] }"
                 placeholder="Nazwisko">
          <p class="error"
             v-if="errors['contractor_data.last_name']"
             v-text="errors['contractor_data.last_name'][0]">
          </p>
        </div>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="500">
      <div class="form-group" v-show="show">
        <label>E-mail:</label>
        <div class="input-wrapper">
          <input type="email"
                 id="email"
                 v-model="contractor_email"
                 :class="{'input-error' : errors['contractor_data.email'] }"
                 placeholder="E-mail">
          </div>
        <p class="error"
           v-if="errors['contractor_data.email']"
           v-text="errors['contractor_data.email'][0]">
        </p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="600">
      <div class="form-group" v-show="show">
        <label>Telefon:</label>
        <div class="input-wrapper">
          <input type="tel"
                 v-model="contractor_phone_number"
                 :class="{'input-error' : errors['contractor_data.phone_number'] }"
                 v-mask="'#########'"
                 placeholder="Telefon">
        </div>
        <p class="error"
           v-if="errors['contractor_data.phone_number']"
           v-text="errors['contractor_data.phone_number'][0]">
        </p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="500" :delay="600">
      <div v-if="show" class="box-info warning">
        Jeżeli właściciel lokalu posiada już konto w Portalu Gastro na numer ID_SFA,
        na który w tej chwili podpisywana jest umowa, w tym miejscu należy podać ten sam
        numer telefonu, który został wykorzystany przy zakładaniu konta w Portalu
        Gastro.
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="700">
      <div class="form-group" v-show="show">
        <label>Data urodzin:</label>
        <div class="input-wrapper">
          <input type="date" 
                 v-model="contractor_birthday"
                 :class="{'input-error' : errors['contractor_data.birthday'] }"
                 placeholder="Data urodzin">
        </div>
        <p class="error"
           v-if="errors['contractor_data.birthday']"
           v-text="errors['contractor_data.birthday'][0]">
        </p>
      </div>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="800">
      <p v-show="show">Podaj dane Przedstawieciela Handlowego.</p>
    </slide-x-left-transition>

    <slide-x-left-transition :duration="400" :delay="900">
      <div class="form-group" v-show="show">
        <label>Imię:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="sales_representative_first_name"
                 :class="{'input-error' : errors['sales_representative_data.first_name'] }"
                 placeholder="Imię">
        </div>
        <p class="error"
           v-if="errors['sales_representative_data.first_name']"
           v-text="errors['sales_representative_data.first_name'][0]">
        </p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="1000">
      <div class="form-group" v-show="show">
        <label>Nazwisko:</label>
        <div class="input-wrapper">
          <input type="text"
                 v-model="sales_representative_last_name"
                 :class="{'input-error' : errors['sales_representative_data.last_name'] }"
                 placeholder="Nazwisko">
        </div>
        <p class="error"
           v-if="errors['sales_representative_data.last_name']"
           v-text="errors['sales_representative_data.last_name'][0]">
        </p>
      </div>
    </slide-x-left-transition>
    <slide-y-up-transition :duration="500" :delay="400">
      <div v-if="show">
        <ion-button mode="ios"
                    fill="outline"
                    size="small"
                    @click="goToStep(1)"
                    class="mt-10">Wstecz
        </ion-button>
        <ion-button mode="ios"
                    size="small"
                    @click="postSides"
                    class="mt-10">Przejdź dalej
        </ion-button>
      </div>
    </slide-y-up-transition>
  </form>
</template>

<script>
  import { createHelpers } from 'vuex-map-fields';
  import {mapState} from "vuex";

  const { mapFields } = createHelpers({
    getterType: `loyalty/getField`,
    mutationType: `loyalty/updateField`,
  });

  export default {
    name: 'LoyaltySignupSides',
    computed: {
      ...mapFields({
        contractor_first_name: 'signupForm.contractor_data.first_name',
        contractor_last_name: 'signupForm.contractor_data.last_name',
        contractor_email: 'signupForm.contractor_data.email',
        contractor_phone_number: 'signupForm.contractor_data.phone_number',
        contractor_birthday: 'signupForm.contractor_data.birthday',
        sales_representative_first_name: 'signupForm.sales_representative_data.first_name',
        sales_representative_last_name: 'signupForm.sales_representative_data.last_name',
      }),
      ...mapState({
        errors: state => state.loyalty.errors,
      })
    },
    data() {
      return {
        show: false,
      }
    },
    mounted(){
      this.show = true
    },
    methods: {
      goToStep(step){
        this.$store.commit('loyalty/LOYALTY_SET_SIGNUP_CURRENT_STEP', step)
      },
      postSides(){
        console.log('postSides')
        this.$store.dispatch('loyalty/LOYALTY_CONTRACT_STORE_REQUEST', 3)
      }
    }
  }
</script>